module.exports = __webpack_public_path__ + "img/358-4cd19e.png";